import { FileText, X } from 'lucide-react'
import { useRef } from 'react'
import type { MouseEvent } from 'react'
import { intent } from '../content/site'
import { ArrowIcon } from './ArrowIcon'
import { Reveal } from './Reveal'
import { SectionLabel } from './SectionLabel'

export function LetterOfIntent() {
  const dialogRef = useRef<HTMLDialogElement>(null)

  return (
    <section className="section intent-section" id="intent">
      <div className="shell intent-grid">
        <div className="intent-label-column">
          <SectionLabel number="01" label="Intent" />
          <FileText className="intent-icon" aria-hidden="true" strokeWidth={1.35} />
        </div>
        <Reveal className="intent-copy">
          <p className="section-kicker">Letter of Intent</p>
          <h2>Intent to establish BISEN at KCC Mall.</h2>
          <p className="section-lede">{intent.preview}</p>
        </Reveal>
        <Reveal className="document-teaser media-cut" delay={0.06}>
          <div className="document-topline">
            <span>Addressed to</span>
            <strong>{intent.to}</strong>
          </div>
          <div className="document-rule" />
          <p className="document-subject">{intent.subject}</p>
          <p>{intent.paragraphs[0]}</p>
          <button className="text-link text-link--button" type="button" onClick={() => dialogRef.current?.showModal()}>
            Read full letter <ArrowIcon />
          </button>
        </Reveal>
      </div>

      <dialog className="letter-dialog" ref={dialogRef} onClick={(event: MouseEvent<HTMLDialogElement>) => {
        if (event.target === dialogRef.current) dialogRef.current?.close()
      }}>
        <div className="letter-dialog-inner">
          <div className="dialog-header">
            <div>
              <span className="eyebrow">BISEN · Letter of Intent</span>
              <h3>{intent.subject}</h3>
            </div>
            <button className="dialog-close" type="button" onClick={() => dialogRef.current?.close()} aria-label="Close letter">
              <X aria-hidden="true" />
            </button>
          </div>
          <div className="letter-body">
            <p className="letter-to">To: {intent.to}</p>
            <p>{intent.preview}</p>
            {intent.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </div>
      </dialog>
    </section>
  )
}
